/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'iQDnR7ypE4UovZReMp1mhk.png': { uri: '/images/iQDnR7ypE4UovZReMp1mhk.png' },
'fonWK7mbYm6tdGA9sH7KHR.png': { uri: '/images/fonWK7mbYm6tdGA9sH7KHR.png' },
'qDnALNwrB3Wvkvg2ksLKyM.png': { uri: '/images/qDnALNwrB3Wvkvg2ksLKyM.png' },
'2Chubp7znDDBFNMMwYGDyj.png': { uri: '/images/2Chubp7znDDBFNMMwYGDyj.png' },
'qYfRnLfuFkJ12nfsY6zhxG.png': { uri: '/images/qYfRnLfuFkJ12nfsY6zhxG.png' },
'615ypB8p2ZQPYQgDAoVXyy.png': { uri: '/images/615ypB8p2ZQPYQgDAoVXyy.png' },
'bUN96GPP5HAN9VLeyPnv63.png': { uri: '/images/bUN96GPP5HAN9VLeyPnv63.png' },
'6ocY7QqvemJygRnkwzicBm.png': { uri: '/images/6ocY7QqvemJygRnkwzicBm.png' },
'kQvo5AoYW715FuDa9kUitf.png': { uri: '/images/kQvo5AoYW715FuDa9kUitf.png' },
'f2eZngdSBkLN7AUtV5DyTG.png': { uri: '/images/f2eZngdSBkLN7AUtV5DyTG.png' },
'5zBFXD9o8mCTDWJi17nNE3.png': { uri: '/images/5zBFXD9o8mCTDWJi17nNE3.png' },
'2mUYCEdVChK6ecgvMpczJm.png': { uri: '/images/2mUYCEdVChK6ecgvMpczJm.png' },
'b2gHybY38xcz3P3GPe1AGa.png': { uri: '/images/b2gHybY38xcz3P3GPe1AGa.png' },
'6bDqDjyCBcxjNbbULHSgGC.png': { uri: '/images/6bDqDjyCBcxjNbbULHSgGC.png' },
'tzbhcHc1P3FyX8gqZbfVA6.png': { uri: '/images/tzbhcHc1P3FyX8gqZbfVA6.png' },
'5dXnMVmYeWMkJo7NJKufQK.png': { uri: '/images/5dXnMVmYeWMkJo7NJKufQK.png' },
'ec2M9stFPA3CXLGSHWRJxo.webp': { uri: '/images/ec2M9stFPA3CXLGSHWRJxo.webp' },
'5WVdu6VpU1q9ZduPdbH5R1.png': { uri: '/images/5WVdu6VpU1q9ZduPdbH5R1.png' },
'2MkffY9qRkY7Ja4BUiKx3R.png': { uri: '/images/2MkffY9qRkY7Ja4BUiKx3R.png' },
'4CwNy176GDCwc2pRuMZ1pt.png': { uri: '/images/4CwNy176GDCwc2pRuMZ1pt.png' },
'adMCaNiYGk8tobGuB6WnNg.png': { uri: '/images/adMCaNiYGk8tobGuB6WnNg.png' },
'iiZrBnAijqTYXSGLkKzTnD.png': { uri: '/images/iiZrBnAijqTYXSGLkKzTnD.png' },
'7rF47HE2DEm6nCWLpJDdKp.png': { uri: '/images/7rF47HE2DEm6nCWLpJDdKp.png' },
'bakfXyAmPfRJt8tEQMPAta.png': { uri: '/images/bakfXyAmPfRJt8tEQMPAta.png' },
'1ApEdsM1hrVtnN7JrAm8Qt.png': { uri: '/images/1ApEdsM1hrVtnN7JrAm8Qt.png' },
'3KbTg7PCq4AUW7Y5HopUdk.png': { uri: '/images/3KbTg7PCq4AUW7Y5HopUdk.png' },
'shJSmMyKBS6X2rwAAXYA9j.png': { uri: '/images/shJSmMyKBS6X2rwAAXYA9j.png' },
'wcpJsckWsM2oHMcdH9xH71.png': { uri: '/images/wcpJsckWsM2oHMcdH9xH71.png' },
'aDDxMawrZFqyqj8K5c5LJC.png': { uri: '/images/aDDxMawrZFqyqj8K5c5LJC.png' },
'q55EMGDQD94S3687G8hjcw.png': { uri: '/images/q55EMGDQD94S3687G8hjcw.png' },
'3H8iBCWR62BTPxLWPH6Zwr.png': { uri: '/images/3H8iBCWR62BTPxLWPH6Zwr.png' },
'mQvCsLoz2XZqDL9pv6iQdC.png': { uri: '/images/mQvCsLoz2XZqDL9pv6iQdC.png' },
'4rJ4C37A4KNnmgrPhRvioy.png': { uri: '/images/4rJ4C37A4KNnmgrPhRvioy.png' },
'6v8bgts6YrxPauCaGMtYqQ.png': { uri: '/images/6v8bgts6YrxPauCaGMtYqQ.png' },
'acmHDKdfA21FXbSk8Bduiv.png': { uri: '/images/acmHDKdfA21FXbSk8Bduiv.png' },
'enmFJk1t1McqxXphTafZFC.png': { uri: '/images/enmFJk1t1McqxXphTafZFC.png' },
'sY1MZYnyMAJJbwHH7dQ4ax.png': { uri: '/images/sY1MZYnyMAJJbwHH7dQ4ax.png' },
'1rDwqUx3GrmGvKNwMBfRYw.png': { uri: '/images/1rDwqUx3GrmGvKNwMBfRYw.png' }
}

export default imageStaticSourcesByFileName
